<template>
  <div id="search" class="mainBlock" style="padding-bottom: 80px">
    <div
      :style="{
        'margin-top': showXianhuo ? '0' : '64px',
        'padding-top': showXianhuo ? '0' : '80px',
      }"
      style="
        width: 100%;
        height: 100%;
        background-color: #fafafa;
        padding-bottom: 0px;
      "
    >
      <allMallSerch
        v-if="!showXianhuo"
        @initSearch="initSearch"
        :nowPage="true"
        ref="allMallSerch"
        style="border-bottom: 1px solid #e6e6e6"
      ></allMallSerch>
      <div style="width: 1300px; margin: auto">
        <div class="t_r">
          <div class="dis_line bishi">
            <div
              :style="{
                // flex: '1',
                'border-radius': '5px',
                marginLeft: 'auto',
                padding: '0',
                height: '37px',
                marginBottom: '9px',
                borderRadius: '0',
                boxSizing: 'border-box',
                fontSize: '16px',
                display: 'flex',
                alignItems: 'center',
                paddingLeft: '18px',
                background: !isBishiTime ? '#d71e1e' : '#999999',
                padding: '0 24px',
                borderRight: '1px solid #fff'
              }"
              class="p_10 m_t_10 t_c colorWhite font20"
              v-if="showXianhuo"
            >
              <template v-if="!isBishiTime">
                <div class="dis_line v_m" style="margin-right: 8px;">闭市时间:</div>
                <div class="dis_line v_m f_w">
                  <span class="countDown">{{ returnHour(bishiTime, 1, 0) }}</span>
                  <span class="countDown">{{ returnHour(bishiTime, 1, 1) }}</span> :
                  <span class="countDown">{{ returnHour(bishiTime, 2, 0) }}</span>
                  <span class="countDown">{{ returnHour(bishiTime, 2, 1) }}</span> :
                  <span class="countDown">{{ returnHour(bishiTime, 3, 0) }}</span>
                  <span class="countDown">{{ returnHour(bishiTime, 3, 1) }}</span>
                </div>
              </template>
              <template v-else>
                <div class="dis_line v_m">已闭市</div>
              </template>
            </div>
            <div
              @click="changeShowDetail"
              style="cursor: pointer; margin-top: 20px"
              class="yellowBtn"
            >
              <span style="margin-right: 10px">{{
                showDetail ? "收起搜索" : "详细搜索"
              }}</span>
              <i
                :style="{
                  transform: showDetail ? 'rotate(180deg)' : 'rotate(0deg)',
                }"
                style="font-size: 12px"
                class="icon iconfont dis_line iconicon_7"
              ></i>
            </div>
          </div>
        </div>
        <!--      <div style="border-bottom: 1px solid #eee" class="typeBlock">-->
        <!--        <div @click="changeCate(index)" :class="selectIndex === index ? 'selected' : ''" :key="index" v-for="(item, index) in CategoryList">{{ item.name }}</div>-->
        <!--      </div>-->
        <div
          id="detailSearchPlace"
          :style="{ padding: showDetail ? '10px' : '0' }"
          class="detailBack"
        >
          <div>
            <div class="detailSearch">
              <div>分类:</div>
              <div id="secondCategoryListDiv">
                <div>
                  <span
                    @click="allSearchChangeFun(true)"
                    :class="
                      postData.secondCategoryList.length === 0 ? 'active' : ''
                    "
                    class="allSearchSpanItem"
                  >
                    <label :for="'CategoryList2' + '00'">全部</label>
                    <input
                      :value="''"
                      style="display: none"
                      :id="'CategoryList2' + '00'"
                      name="newCateList"
                      type="radio"
                    />
                  </span>
                  <span
                    @click="allSearchChangeFun"
                    :class="
                      postData.secondCategoryList.indexOf(item.categoryId) >= 0
                        ? 'active'
                        : ''
                    "
                    class="allSearchSpanItem"
                    :key="index"
                    v-for="(item, index) in CategoryList"
                  >
                    <label :for="'CategoryList2' + index">{{
                      item.name
                    }}</label>
                    <input
                      v-model="postData.secondCategoryList[0]"
                      :value="item.categoryId"
                      style="display: none"
                      :id="'CategoryList2' + index"
                      name="newCateList"
                      type="radio"
                    />
                  </span>
                </div>
              </div>
              <div>
                <span
                  @click="openMore('secondCategoryListDiv', 4)"
                  class="allSearchSpanItem"
                >
                  <span>{{ showMoreModel[4] ? "收起" : "更多" }}</span>
                  <i
                    :style="{
                      transform: showMoreModel[4]
                        ? 'rotate(180deg)'
                        : 'rotate(0deg)',
                    }"
                    style="font-size: 12px"
                    class="icon iconfont dis_line iconicon_7"
                  ></i>
                </span>
              </div>
            </div>
            <div class="detailSearch">
              <div>材质:</div>
              <div id="MaterialQualityListDiv">
                <div>
                  <span
                    @click="searchTab(multipleShowModel[0])"
                    :class="
                      postData.materialQualityIdList.indexOf(item.id) >= 0
                        ? 'active'
                        : ''
                    "
                    class="allSearchSpanItem"
                    :key="index"
                    v-for="(item, index) in MaterialQualityList"
                  >
                    <label :for="'MaterialQualityList' + index">{{
                      item.name
                    }}</label>
                    <input
                      v-if="multipleShowModel[0]"
                      v-model="postData.materialQualityIdList"
                      :value="item.id"
                      style="display: none"
                      :id="'MaterialQualityList' + index"
                      type="checkbox"
                    />
                    <input
                      v-if="!multipleShowModel[0]"
                      v-model="postData.materialQualityIdList[0]"
                      :value="item.id"
                      style="display: none"
                      :id="'MaterialQualityList' + index"
                      name="MaterialQualityListRedio"
                      type="radio"
                    />
                  </span>
                </div>
              </div>
              <div>
                <!--                <input class="allInput" style="width: 80px;border: 1px solid #eee" placeholder="输入文字搜索" type="text">-->
                <span
                  @click="changeMedu(0, 'materialQualityIdList')"
                  :class="multipleShowModel[0] ? 'active' : ''"
                  style="margin-right: 0; border: 1px solid #f1f1f1"
                  class="allSearchSpanItem"
                  >多选 +</span
                >
                <span
                  @click="openMore('MaterialQualityListDiv', 0)"
                  class="allSearchSpanItem"
                >
                  <span>{{ showMoreModel[0] ? "收起" : "更多" }}</span>
                  <i
                    :style="{
                      transform: showMoreModel[0]
                        ? 'rotate(180deg)'
                        : 'rotate(0deg)',
                    }"
                    style="font-size: 12px"
                    class="icon iconfont dis_line iconicon_7"
                  ></i>
                </span>
              </div>
            </div>
            <div class="detailSearch">
              <div>规格:</div>
              <div>
                <input
                  class="allInput"
                  @keyup.enter="getAllList(1)"
                  placeholder="输入规格搜索(1000*10*10)"
                  style="border: 1px solid #eee; border-radius: 0"
                  v-model="postData.guige"
                  type="text"
                />
                <span style="margin-left: 10px"
                  >长：
                  <input
                    v-model="postData.minWidth"
                    style="
                      border: 1px solid #eee;
                      border-radius: 0;
                      width: 50px;
                    "
                    class="allInput"
                    type="text"
                  />
                  -
                  <input
                    v-model="postData.maxWidth"
                    @keyup.enter="getAllList(1)"
                    style="
                      border: 1px solid #eee;
                      border-radius: 0;
                      width: 50px;
                    "
                    class="allInput"
                    type="text"
                  />
                </span>
                <span style="margin-left: 10px"
                  >宽：
                  <input
                    v-model="postData.minLength"
                    style="
                      border: 1px solid #eee;
                      border-radius: 0;
                      width: 50px;
                    "
                    class="allInput"
                    type="text"
                  />
                  -
                  <input
                    v-model="postData.maxLength"
                    @keyup.enter="getAllList(1)"
                    style="
                      border: 1px solid #eee;
                      border-radius: 0;
                      width: 50px;
                    "
                    class="allInput"
                    type="text"
                  />
                </span>
                <span style="margin-left: 10px"
                  >厚：
                  <input
                    v-model="postData.minThickness"
                    style="
                      border: 1px solid #eee;
                      border-radius: 0;
                      width: 50px;
                    "
                    class="allInput"
                    type="text"
                  />
                  -
                  <input
                    v-model="postData.maxThickness"
                    @keyup.enter="getAllList(1)"
                    style="
                      border: 1px solid #eee;
                      border-radius: 0;
                      width: 50px;
                    "
                    class="allInput"
                    type="text"
                  />
                </span>
              </div>
              <div></div>
            </div>
            <div class="detailSearch">
              <div>钢厂:</div>
              <div id="SteelMillListDiv">
                <div>
                  <span
                    @click="searchTab(multipleShowModel[1])"
                    :class="
                      postData.steelMillIdList.indexOf(item.id) >= 0
                        ? 'active'
                        : ''
                    "
                    class="allSearchSpanItem"
                    :key="index"
                    v-for="(item, index) in SteelMillList"
                  >
                    <label :for="'SteelMillList' + index">{{
                      item.name
                    }}</label>
                    <input
                      v-if="multipleShowModel[1]"
                      v-model="postData.steelMillIdList"
                      :value="item.id"
                      style="display: none"
                      :id="'SteelMillList' + index"
                      type="checkbox"
                    />
                    <input
                      v-if="!multipleShowModel[1]"
                      v-model="postData.steelMillIdList[0]"
                      :value="item.id"
                      style="display: none"
                      :id="'SteelMillList' + index"
                      name="SteelMillListRadio"
                      type="radio"
                    />
                  </span>
                </div>
              </div>
              <div>
                <!--                <input class="allInput" style="width: 80px;border: 1px solid #eee" placeholder="输入文字搜索" type="text">-->
                <span
                  @click="changeMedu(1, 'steelMillIdList')"
                  :class="multipleShowModel[1] ? 'active' : ''"
                  style="margin-right: 0; border: 1px solid #f1f1f1"
                  class="allSearchSpanItem"
                  >多选 +</span
                >
                <span
                  @click="openMore('SteelMillListDiv', 1)"
                  class="allSearchSpanItem"
                >
                  <span>{{ showMoreModel[1] ? "收起" : "更多" }}</span>
                  <i
                    :style="{
                      transform: showMoreModel[1]
                        ? 'rotate(180deg)'
                        : 'rotate(0deg)',
                    }"
                    style="font-size: 12px"
                    class="icon iconfont dis_line iconicon_7"
                  ></i>
                </span>
              </div>
            </div>
            <div class="detailSearch">
              <div>品名:</div>
              <div>
                <input
                  class="allInput"
                  v-model="postData.name"
                  @keyup.enter="getAllList(1)"
                  placeholder="输入品名搜索"
                  style="border: 1px solid #eee; border-radius: 0"
                  type="text"
                />
              </div>
              <div></div>
            </div>
            <div class="detailSearch">
              <div>仓库:</div>
              <div id="WarehouseListDiv">
                <div>
                  <span
                    @click="searchTab(multipleShowModel[2])"
                    :class="
                      postData.warehouseIdList.indexOf(item.id) >= 0
                        ? 'active'
                        : ''
                    "
                    class="allSearchSpanItem"
                    :key="index"
                    v-for="(item, index) in WarehouseList"
                  >
                    <label :for="'WarehouseList' + index">{{
                      item.name
                    }}</label>
                    <input
                      v-if="multipleShowModel[2]"
                      v-model="postData.warehouseIdList"
                      :value="item.id"
                      style="display: none"
                      :id="'WarehouseList' + index"
                      type="checkbox"
                    />
                    <input
                      v-if="!multipleShowModel[2]"
                      v-model="postData.warehouseIdList[0]"
                      :value="item.id"
                      style="display: none"
                      :id="'WarehouseList' + index"
                      name="WarehouseListRadio"
                      type="radio"
                    />
                  </span>
                </div>
              </div>
              <div>
                <!--                <input @keydown.enter="getAllSearchList(2, $event.target.value, 1, 10)" class="allInput" style="width: 80px;border: 1px solid #eee" placeholder="输入文字搜索" type="text">-->
                <span
                  @click="changeMedu(2, 'warehouseIdList')"
                  :class="multipleShowModel[2] ? 'active' : ''"
                  style="margin-right: 0; border: 1px solid #f1f1f1"
                  class="allSearchSpanItem"
                  >多选 +</span
                >
                <span
                  @click="openMore('WarehouseListDiv', 2)"
                  class="allSearchSpanItem"
                >
                  <span>{{ showMoreModel[2] ? "收起" : "更多" }}</span>
                  <i
                    :style="{
                      transform: showMoreModel[2]
                        ? 'rotate(180deg)'
                        : 'rotate(0deg)',
                    }"
                    style="font-size: 12px"
                    class="icon iconfont dis_line iconicon_7"
                  ></i>
                </span>
              </div>
            </div>
            <div class="detailSearch">
              <div>重量:</div>
              <div>
                <span
                  @click="searchWeight(item)"
                  :class="
                    postData.minWeight === item.min &&
                    postData.maxWeight === item.max
                      ? 'active'
                      : ''
                  "
                  class="allSearchSpanItem"
                  :key="index"
                  v-for="(item, index) in weightList"
                >
                  <label>{{ item.name }}</label>
                </span>
                <input
                  v-model="postData.minWeight"
                  class="allInput"
                  style="border: 1px solid #eee; border-radius: 0; width: 50px"
                  type="text"
                />
                -
                <input
                  v-model="postData.maxWeight"
                  class="allInput"
                  @keyup.enter="getAllList(1)"
                  style="border: 1px solid #eee; border-radius: 0; width: 50px"
                  type="text"
                />
              </div>
              <div></div>
            </div>
            <div class="detailSearch">
              <div>产地:</div>
              <div id="ChandiListDiv">
                <div>
                  <span
                    @click="searchTab(multipleShowModel[3])"
                    :class="
                      postData.originPlaceIdList.indexOf(item.id) >= 0
                        ? 'active'
                        : ''
                    "
                    class="allSearchSpanItem"
                    :key="index"
                    v-for="(item, index) in ChandiList"
                  >
                    <label :for="'ChandiList' + index">{{ item.name }}</label>
                    <input
                      v-if="multipleShowModel[3]"
                      v-model="postData.originPlaceIdList"
                      :value="item.id"
                      style="display: none"
                      :id="'ChandiList' + index"
                      type="checkbox"
                    />
                    <input
                      v-if="!multipleShowModel[3]"
                      v-model="postData.originPlaceIdList[0]"
                      :value="item.id"
                      style="display: none"
                      :id="'ChandiList' + index"
                      name="ChandiListRadio"
                      type="radio"
                    />
                  </span>
                </div>
              </div>
              <div>
                <!--                <input class="allInput" style="width: 80px;border: 1px solid #eee" placeholder="输入文字搜索" type="text">-->
                <span
                  @click="changeMedu(3, 'originPlaceIdList')"
                  :class="multipleShowModel[3] ? 'active' : ''"
                  style="margin-right: 0; border: 1px solid #f1f1f1"
                  class="allSearchSpanItem"
                  >多选 +</span
                >
                <span
                  @click="openMore('ChandiListDiv', 3)"
                  class="allSearchSpanItem"
                >
                  <span>{{ showMoreModel[3] ? "收起" : "更多" }}</span>
                  <i
                    :style="{
                      transform: showMoreModel[3]
                        ? 'rotate(180deg)'
                        : 'rotate(0deg)',
                    }"
                    style="font-size: 12px"
                    class="icon iconfont dis_line iconicon_7"
                  ></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!showDetail" class="quickTopSearch">
          <span
            @click="allSearchChangeFun"
            v-if="index < 20"
            :key="index"
            v-for="(item, index) in CategoryList"
          >
            <label
              :class="
                postData.secondCategoryList.indexOf(item.categoryId) >= 0
                  ? 'active'
                  : ''
              "
              :for="'CategoryList2' + index"
              >{{ item.name }}</label
            >
            <input
              v-model="postData.secondCategoryList[0]"
              :value="item.categoryId"
              style="display: none"
              :id="'CategoryList2' + index"
              name="newCateList"
              type="radio"
            />
          </span>
        </div>
        <div class="searchInputPlace">
          <div style="margin-left: 40px" class="dis_line">
            <span>品名:</span>
            <span
              ><input
                @keyup.enter="getAllList(1)"
                v-model="postData.name"
                style="border: 1px solid #eee; width: 60px"
                class="allInput"
                type="text"
            /></span>
          </div>
          <div style="margin-left: 10px" class="dis_line">
            <span>规格:</span>
            <span
              ><input
                @keyup.enter="getAllList(1)"
                v-model="postData.guige"
                style="border: 1px solid #eee; width: 120px"
                class="allInput"
                type="text"
            /></span>
          </div>
          <div style="margin-left: 10px" class="dis_line">
            <!-- <span>供应商:</span>
            <span>
              <input
                v-model="postData.accountName"
                style="border: 1px solid #eee; width: 62px"
                class="allInput"
                type="text"
              />
            </span> -->
          </div>
          <div style="margin-left: 10px" class="dis_line">
            <span>重量:</span>
            <span>
              <input
                v-model="postData.minWeight"
                style="border: 1px solid #eee; width: 62px"
                class="allInput"
                type="text"
              />
              -
              <input
                @keyup.enter="getAllList(1)"
                v-model="postData.maxWeight"
                style="border: 1px solid #eee; width: 62px"
                class="allInput"
                type="text"
              />
            </span>
          </div>
          <div style="margin-left: 10px" class="dis_line">
            <span>价格区间:</span>
            <span>
              <input
                class="allInput"
                style="width: 62px; border: 1px solid #eee"
                type="text"
                v-model="postData.minPrice"
              />
              &nbsp;-&nbsp;
              <input
                @keyup.enter="getAllList(1)"
                class="allInput"
                style="width: 62px; border: 1px solid #eee"
                type="text"
                v-model="postData.maxPrice"
              />
            </span>
          </div>
          <div style="border: none; margin-left: 30px" class="dis_line t_c">
            <button @click="getAllList(1)" class="redButton">搜索</button>
            <button @click="resetSearch" class="cancelButton">重置</button>
          </div>
        </div>
        <div class="filterBlock">
          <div class="selected d_flex">
            <div>已搜索：</div>
            <div class="seltedItem d_flex">
              <div v-if="postData.name">
                {{ postData.name
                }}<img
                  style="height: 15px; width: 14px"
                  src="../../../../assets/img/selected.png"
                />
              </div>
              <div v-if="postData.guige">
                {{ postData.guige
                }}<img
                  style="height: 15px; width: 14px"
                  src="../../../../assets/img/selected.png"
                />
              </div>
              <div v-if="postData.minWeight && postData.maxWeight">
                {{ postData.minWeight + "-" + postData.maxWeight + "吨"
                }}<img
                  style="height: 15px; width: 14px"
                  src="../../../../assets/img/selected.png"
                />
              </div>
            </div>
          </div>
          <!--        <div class="norm d_flex">-->
          <!--          <div style="margin-right: 12px">价格区间</div>-->
          <!--          <div class="inputBlock d_flex"><input style="width: 62px" type="text" v-model="postData.minPrice" placeholder="最小值"/></div>-->
          <!--          &nbsp;-&nbsp;-->
          <!--          <div class="inputBlock d_flex"><input style="width: 62px" type="text" v-model="postData.maxPrice" placeholder="最大值"/></div>-->
          <!--          <div @click="getAllList" class="normBtn c_p" style="margin-left: 20px;color:#fff;background:#DB4040;">筛选</div>-->
          <!--&lt;!&ndash;          <div class="normBtn c_p">取消</div>&ndash;&gt;-->
          <!--        </div>-->
          <div style="cursor: pointer; margin-right: 20px">
            <span @click="showTab = !showTab">切换列表</span>
          </div>
        </div>
        <div
          v-if="goodList.length === 0"
          style="
            width: 60%;
            margin: auto;
            margin-top: 2%;
            padding-bottom: 100px;
          "
        >
          <img
            src="../../../../assets/img/searchNo.png"
            style="margin-left: 40%"
            width="20%"
          />
          <div style="margin-top: 20px" class="t_c">
            暂未搜到商品，换个关键词试试？
          </div>
        </div>
        <div
          v-show="showTab && goodList.length > 0"
          style="padding-bottom: 40px"
          class="resultBlock"
        >
          <div :key="index" v-for="(item, index) in goodList" class="item">
            <img :src="item.masterImgUrl" />
            <div class="info">
              <div class="name m_b_5">{{ item.categorySecondName }}</div>
              <div class="d_flex m_b_5">
                <div class="color000">{{ item.name }}</div>
                <div class="color666 font12">{{ item.guige }}</div>
              </div>
              <div class="d_flex m_b_10">
                <div class="color000 font12">过磅价格：{{ baigangToken ? item.price : '**' }}</div>
                <div class="color666 font12">{{ item.categoryFirstName }}</div>
              </div>
              <div class="color666 font12">
                <img
                  style="height: 13px; width: 13px; margin-right: 2px"
                  src="../../../../assets/img/xingzhuang.png"
                />{{ item.warehouseName }}
              </div>
            </div>
            <div class="hoverBlock">
              <div class="bgBlock"></div>
              <div class="content">
                <span>商品详情:</span>
                <div v-html="item.details"></div>
                <div>
                  <div class="m_t_10 m_b_10">备注:</div>
                  <div style="max-width: 200px; overflow-wrap: anywhere">
                    {{ item.remarks }}
                  </div>
                </div>
              </div>
              <div class="btnBlock">
                <div
                  :style="{ 'background-color': isRegister ? '' : '#eeeeee' }"
                  @click="allCollect(item)"
                  class="c_p"
                >
                  加入收藏夹
                </div>
                <div
                  @click="showModelFun(item)"
                  class="c_p"
                  style="background: #e8774e"
                >
                  人工咨询
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-show="!showTab && goodList.length > 0"
          class="resultList"
          style=""
        >
          <table>
            <thead>
              <tr>
                <th>品名</th>
                <th>规格</th>
                <th>长度(米)</th>
                <th>重量/公差范围</th>
                <th>材质</th>
                <th>产地</th>
                <th>仓库</th>
                <!--<th>过磅价格</th>-->
                <!--<th>理算价格</th>-->
                <th>数量（单位）</th>
                <th>总重量（吨）</th>
                <!-- <th>供应商</th> -->
                <th>单价</th>
                <th>购买数量</th>
                <!-- <th>备注</th> -->
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr :key="index" v-for="(item, index) in goodList">
                <td>
                  <a @click="openGoodDetail(item)" class="colorBlue00A6EC">{{
                    item.name
                  }}</a>
                </td>
                <td>
                  <span class="dis_line">{{ item.guige }}</span>
                  <div class="dis_line v_m p_r">
                    <i
                      class="
                        icon
                        iconfont
                        iconyanjing
                        colorBlue00A6EC
                        showTile
                        f_w
                      "
                      style="font-weight: normal !important"
                    ></i>
                    <div
                      class="p_a tabTilUp"
                      style="
                        font-weight: normal !important;
                        width: 250px;
                        z-index: 999;
                      "
                    >
                      <span style="overflow-wrap: anywhere; width: 600px">
                        {{ item.remarks }}
                      </span>
                      <!-- <span class="p_r font12">
                        <span style="display: block"
                          ><span>长度：</span
                          ><span class="f_w">{{
                            item.length || "-"
                          }}</span></span
                        >
                        <span style="display: block"
                          ><span>宽度：</span
                          ><span class="f_w">{{
                            item.breadth || "-"
                          }}</span></span
                        >
                        <span style="display: block"
                          ><span>厚度：</span
                          ><span class="f_w">{{
                            item.depth || "-"
                          }}</span></span
                        >
                        <span style="display: block"
                          ><span>直径：</span
                          ><span class="f_w">{{
                            item.diameter || "-"
                          }}</span></span
                        >
                        <span style="display: block"
                          ><span>外径：</span
                          ><span class="f_w">{{
                            item.outDiameter || "-"
                          }}</span></span
                        >
                        <span style="display: block"
                          ><span>壁厚：</span
                          ><span class="f_w">{{
                            item.schedule || "-"
                          }}</span></span
                        >
                        <span style="display: block"
                          ><span>长边宽：</span
                          ><span class="f_w">{{
                            item.outBreadth || "-"
                          }}</span></span
                        > -->
                      <i></i>
                      <!-- </span> -->
                    </div>
                  </div>
                </td>
                <td>
                  {{ item.length ? item.length / 100 : "-" }}
                </td>
                <td>{{ item.tolerance || "-" }}</td>
                <td>{{ item.materialQualityName || "-" }}</td>
                <td class="colorBlue00A6EC">
                  {{ item.originPlaceName || "-" }}
                </td>
                <td class="colorBlue00A6EC">
                  <span
                    @click="showDetailFun(item)"
                    style="text-decoration: underline"
                    class="c_p"
                    >{{ item.warehouseName || "-" }}</span
                  >
                </td>
                <td class="">
                  {{
                    baigangToken ?
                      item.stock || "-"
                      : "**"
                  }}
                </td>
                <td class="">
                  {{
                    baigangToken ?
                      (item.lisuanWeight * item.stock).toFixed(2)
                      : "**"
                  }}
                </td>
                <!-- <td>
                  {{item.accountName}}
                </td> -->
                <!--<td class="colorRed">¥{{ isRegister && parseInt(MemberInfo.account && MemberInfo.account.companyAuth) === 2 ? item.price : '**'}}</td>-->
                <!--<td class="colorRed">¥{{ isRegister && parseInt(MemberInfo.account && MemberInfo.account.companyAuth) === 2 ? item.lisuanPrice : '**'}}</td>-->
                <td>
                  <p
                    v-if="
                      item.settlementType === '1' || item.settlementType === '3'
                    "
                    class="m_b_10"
                  >
                    <input
                      type="radio"
                      class="allRadio"
                      :id="'chlidRadio' + index"
                      v-model="item.chooseMethod"
                      :value="1"
                      :name="'childRadioName' + index"
                    />
                    <label :for="'chlidRadio' + index"></label>
                    <label :for="'chlidRadio' + index"><span>理计</span></label>
                    <span class="colorRed"
                      >¥{{
                        baigangToken
                          ? item.lisuanPrice
                          : "**"
                      }}</span
                    >
                  </p>
                  <p
                    v-if="
                      item.settlementType === '2' || item.settlementType === '3'
                    "
                  >
                    <input
                      type="radio"
                      class="allRadio"
                      :id="'chlidRadioBangji' + index"
                      v-model="item.chooseMethod"
                      :value="2"
                      :name="'childRadioName' + index"
                    />
                    <label :for="'chlidRadioBangji' + index"></label>
                    <label :for="'chlidRadioBangji' + index">
                      <span>磅计</span>
                    </label>
                    <span class="colorRed"
                      >¥{{
                        baigangToken
                          ? item.price
                          : "**"
                      }}</span
                    >
                  </p>
                  <!-- <p>
                    <span>理计 </span>
                  </p>
                  <p>
                    <span>磅计 </span>
                  </p> -->
                </td>
                <td>
                  <div class="CalculateDiv" style="height: 26px">
                    <span
                      @click="changeNumber('sub', item)"
                      style="line-height: 24px; font-size: 22px; width: 26px"
                      >-</span
                    >
                    <div style="width: 50px">
                      <input
                        readonly
                        v-model="item.number"
                        type="number"
                        placeholder="1"
                      />
                    </div>
                    <span
                      @click="changeNumber('add', item)"
                      style="line-height: 20px; font-size: 20px; width: 26px"
                      >+</span
                    >
                  </div>
                  <!-- <div style="width: 120px">
                    <button
                      style="
                        background-color: #d71e1e;
                        color: #fff;
                        border: none;
                      "
                      @click="changeNumber('sub', item)"
                    >
                      -
                    </button>
                    <input
                      style="width: 60px; border: none"
                      v-model="item.number"
                      type="number"
                      placeholder="1"
                    />
                    <button
                      style="
                        background-color: #d71e1e;
                        color: #fff;
                        border: none;
                      "
                      @click="changeNumber('add', item)"
                    >
                      +
                    </button> -->
                  <!-- </div> -->
                </td>
                <!-- <td width="150px">
                  <div style="max-width: 150px; overflow-y: scroll">
                    {{ item.remarks }}
                  </div>
                </td> -->
                <td>
                  <div
                    :style="{
                      color: isRegister ? '#ffffff' : '#ffffff',
                      backgroundColor: isRegister ? '#d71e1e' : '#aaaaaa',
                      border: 'solid 1px',
                      padding: '5px 10px',
                      borderRadius: '5px',
                      textAlign: 'center',
                    }"
                    :class="isBishiTime ? 'bishitime' : ''"
                    @click="allCollect(item)"
                    class="c_p"
                  >
                    <i
                      :title="'加入购物车'"
                      class="icon iconfont icongouwuche2"
                    ></i>
                    <span>购买</span>
                  </div>
                  <!--                <div @click="showModelFun(item)" class="operate c_p">人工咨询</div>-->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="padding: 10px 0 0; text-align: right">
          <page
            v-if="totalPage !== 0"
            v-on:on-getList="getAllList($event)"
            :totalPage="totalPage"
            :page="page"
            :explain="1"
            :totalCount="totalCount"
          ></page>
        </div>
      </div>
    </div>
    <!--    <div v-if="isRegister" @click="showCollect = true" style="position: fixed;height: 100px;right: 0;top: calc(50% - 50px);padding: 10px; width: 20px;white-space: normal;background-color: #D71E1E;color: #fff;border-radius: 5px 0 0 5px;cursor:pointer;">-->
    <!--      我的收藏夹-->
    <!--    </div>-->
    <model
      v-if="showCollect"
      :onButton="'4'"
      :title="'收藏夹'"
      :minWidth="'1200px'"
      v-on:on-cancel="showCollect = false"
      v-on:on-confirm="applySure()"
    >
      <div class="resultList" style="margin-bottom: 40px">
        <table v-if="collectList.length > 0">
          <thead>
            <tr>
              <th>品名</th>
              <th>类型</th>
              <th>材质</th>
              <th>产地</th>
              <th>过磅价格</th>
              <th>理算价格</th>
              <th>规格</th>
              <th>重量</th>
              <th>仓库</th>
              <th>钢厂</th>
              <!-- <th>备注</th> -->
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="index" v-for="(item, index) in collectList">
              <td>{{ item.shopGoodEntity.name }}</td>
              <td>{{ item.shopGoodEntity.categorySecondName }}</td>
              <td>{{ item.shopGoodEntity.materialQualityName }}</td>
              <td class="colorBlue00A6EC">
                {{ item.shopGoodEntity.originPlaceName }}
              </td>
              <td class="colorRed">¥{{ item.shopGoodEntity.price }}</td>
              <td class="colorRed">¥{{ item.shopGoodEntity.lisuanPrice }}</td>
              <td>
                <span class="dis_line">{{ item.shopGoodEntity.guige }}</span>
                <div class="dis_line v_m p_r">
                  <i
                    class="
                      icon
                      iconfont
                      iconyanjing
                      colorBlue00A6EC
                      showTile
                      f_w
                    "
                    style="font-weight: normal !important"
                  ></i>
                  <div
                    class="p_a tabTilUp"
                    style="
                      top: -142px;
                      left: -28px;
                      font-weight: normal !important;
                      width: 250px;
                    "
                  >
                    <span class="p_r font12">
                      <span style="display: block"
                        ><span>长度：</span
                        ><span class="f_w">{{
                          item.shopGoodEntity.length || "-"
                        }}</span></span
                      >
                      <span style="display: block"
                        ><span>宽度：</span
                        ><span class="f_w">{{
                          item.shopGoodEntity.breadth || "-"
                        }}</span></span
                      >
                      <span style="display: block"
                        ><span>厚度：</span
                        ><span class="f_w">{{
                          item.shopGoodEntity.depth || "-"
                        }}</span></span
                      >
                      <span style="display: block"
                        ><span>直径：</span
                        ><span class="f_w">{{
                          item.shopGoodEntity.diameter || "-"
                        }}</span></span
                      >
                      <span style="display: block"
                        ><span>外径：</span
                        ><span class="f_w">{{
                          item.shopGoodEntity.outDiameter || "-"
                        }}</span></span
                      >
                      <span style="display: block"
                        ><span>壁厚：</span
                        ><span class="f_w">{{
                          item.shopGoodEntity.schedule || "-"
                        }}</span></span
                      >
                      <span style="display: block"
                        ><span>长边宽：</span
                        ><span class="f_w">{{
                          item.shopGoodEntity.outBreadth || "-"
                        }}</span></span
                      >
                      <i></i>
                    </span>
                  </div>
                </div>
              </td>
              <td>
                <p>
                  理重：{{
                    isRegister &&
                    parseInt(
                      MemberInfo.account && MemberInfo.account.companyAuth
                    )
                      ? item.shopGoodEntity.lisuanWeight || "-"
                      : "**"
                  }}t
                </p>
                <p>
                  件重：{{
                    isRegister &&
                    parseInt(
                      MemberInfo.account && MemberInfo.account.companyAuth
                    )
                      ? item.shopGoodEntity.weight || "-"
                      : "**"
                  }}t
                </p>
              </td>
              <td class="colorBlue00A6EC">
                <span
                  @click="showDetailFun(item.shopGoodEntity)"
                  style="text-decoration: underline"
                  class="c_p"
                  >{{ item.shopGoodEntity.warehouseName }}</span
                >
              </td>
              <td>{{ item.shopGoodEntity.steelMillName }}</td>
              <td>
                <!-- {{ item.shopGoodEntity.remarks }} -->
              </td>
              <td>
                <div @click="removeCollect(item)" class="operate c_p">
                  移出收藏夹
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="collectList.length === 0">
          <img
            src="../../../../assets/img/searchNo.png"
            style="margin-left: 45%"
            width="10%"
          />
          <div style="margin-top: 20px" class="t_c">
            您还没有收藏商品，赶紧去收藏吧
          </div>
        </div>
      </div>
      <div
        style="background-color: #eee; color: #999"
        @click="showCollect = false"
        class="rightYellowBtn m_b_20 pointer"
      >
        取消
      </div>
      <div
        @click="showAllModel()"
        :style="{ 'background-color': collectList.length === 0 ? '#eee' : '' }"
        class="rightYellowBtn m_b_20 pointer"
      >
        一键咨询
      </div>
    </model>
    <model
      v-if="showModel"
      :onButton="'4'"
      :title="'咨询'"
      :minWidth="'500px'"
      v-on:on-cancel="showModel = false"
      v-on:on-confirm="applySure()"
    >
      <div class="main_block">
        <div class="bg_block"></div>
        <div
          style="position: relative; padding: 10px 0; margin: auto"
          class="content_block"
        >
          您当前询问的商品为:
          <div :key="index" v-for="(item, index) in askList">
            {{ item.categorySecondName }} - {{ item.name }}
          </div>
        </div>
        <div style="position: relative" class="content_block">
          <div class="input_block">
            <div>您的姓名</div>
            <input
              type="tel"
              maxlength="11"
              placeholder="请输入您的姓名"
              v-model="askData.name"
            />
          </div>
          <div class="input_block">
            <div>您的联系方式</div>
            <input
              type="tel"
              maxlength="11"
              placeholder="请输入手机号"
              v-model="askData.mobile"
            />
          </div>
          <div class="input_block">
            <div>备注</div>
            <input type="text" placeholder="备注" v-model="askData.remarks" />
          </div>
          <button class="loginButton" @click="applySure()">提交</button>
        </div>
      </div>
    </model>
    <div v-show="showDetail2">
      <div style="opacity: 0.5; z-index: 1000" class="cover"></div>
      <div
        style="
          text-align: center;
          position: fixed;
          top: calc((100% - 670px) / 2.6);
          background-color: #fff;
          left: calc(50% - 350px);
          width: 700px;
          z-index: 1001;
        "
      >
        <div style="width: 100%; height: 600px" id="container"></div>
        <button
          @click="showDetail2 = false"
          style="margin: 20px"
          class="cancelButton"
        >
          返回
        </button>
      </div>
    </div>
  </div>
</template>

<script>
let marker
let map
let searchTimeOut
let bishiInterVal
export default {
  name: 'search',
  props: ['showXianhuo', 'from'],
  data () { // 所有的数据都写在里面
    return {
      isBishiTime: false,
      text: this.$route.query.text && this.$route.query.text.split(' '),
      isRefreshShopCar: `isRefreshShopCar`,
      bishiTime: 0,
      isRegister: window.localStorage.getItem('memberId'),
      MemberInfo: JSON.parse(window.localStorage.getItem('MemberInfo') || '{}'),
      showTab: false,
      showDetailSearch: true,
      currentTab: false,
      showDetail: true,
      showDetail2: false,
      showModel: false,
      showCollect: false,
      searchResult: this.$route.query.name,
      CategoryList: [],
      selectIndex: 0,
      goodList: [],
      page: 0,
      totalPage: 0,
      totalCount: 0,
      weightList: [
        {
          name: '1-2吨',
          min: 1,
          max: 2
        },
        {
          name: '2-4吨',
          min: 2,
          max: 4
        },
        {
          name: '4-6吨',
          min: 4,
          max: 6
        },
        {
          name: '6-8吨',
          min: 6,
          max: 8
        },
        {
          name: '8-10吨',
          min: 8,
          max: 10
        },
        {
          name: '10-12吨',
          min: 10,
          max: 12
        }
      ],
      askData: {
        name: '',
        remarks: '',
        mobile: ''
      },
      collectList: [],
      MaterialQualityList: [],
      ChandiList: [],
      WarehouseList: [],
      SteelMillList: [],
      searchData: [
        {
          currPage: 1,
          name: '',
          pageSize: 10
        },
        {
          currPage: 1,
          name: '',
          pageSize: 10
        },
        {
          currPage: 1,
          name: '',
          pageSize: 10
        },
        {
          currPage: 1,
          name: '',
          pageSize: 10
        }
      ],
      postData: {
        ascs: [],
        secondCategoryList: [],
        warehouseIdList: [],
        materialQualityIdList: [],
        steelMillIdList: [],
        originPlaceIdList: [],
        descs: [],
        maxPrice: '',
        publishChannel: '2',
        minPrice: '',
        accountName: '',
        maxLength: '',
        futuresFlag: this.showXianhuo ? '0' : '',
        maxThickness: '',
        maxWeight: '',
        maxWidth: '',
        minLength: '',
        minThickness: '',
        minWeight: '',
        minWidth: '',
        name: '',
        keyWord: this.$route.query.name,
        guige: '',
        pageSize: this.$commonJs.commonPageSize,
        currPage: 0,
        askList: []
      },
      showMoreModel: [
        false,
        false,
        false,
        false,
        false
      ],
      multipleShowModel: [
        false,
        false,
        false,
        false
      ],
      showMoreModelDivName: [
        'MaterialQualityListDiv',
        'SteelMillListDiv',
        'WarehouseListDiv',
        'ChandiListDiv',
        'secondCategoryListDiv'
      ],
      baigangToken: localStorage.getItem('baigangToken')
    }
  },
  created () {
    this.postData.name = this.text && this.text[0]
    this.postData.guige = this.text && this.text[1]
    if (this.from === 'index') {
      document.title = '现货商城 | 百钢商城 | 钢铁电商，百炼成钢'
    } else {
      document.title = '百钢商城 | 钢铁电商，百炼成钢'
    }
    if (this.$route.query.categoryId) {
      this.postData.secondCategoryList[0] = this.$route.query.categoryId
    }
    if (this.$route.query.materId) {
      this.postData.materialQualityIdList[0] = this.$route.query.materId
    }
    if (this.$route.query.chandiId) {
      this.postData.originPlaceIdList[0] = this.$route.query.chandiId
    }
    this.getAllCate()
    this.getAllSearchList()
    if (this.showXianhuo) {
      this.getServiceTime()
    }
    // if (window.localStorage.getItem('memberId')) {
    //   this.getcollectList()
    // }

    // 检测闭市
    this.$commonJs.asyncReturnIsBishiTime().then(
      res => {
        this.isBishiTime = res
      }
    )
  },
  destroyed () {
    clearInterval(bishiInterVal)
  },
  mounted () {
  },
  methods: {
    changeNumber (type, item) {
      if (type) {
        if (type === 'sub') {
          if (item.number > 1) {
            item.number--
          }
        }
        if (type === 'add') {
          if (item.number === null) {
            item.number++
          }
          item.number++
        }
      }
    },
    getServiceTime () {
      this.$axiox.get('/baigang/app/home/queryServiceTime/?accountId=1').then(p => {
        console.log('p', p)
        this.bishiTime = p.data.endTime ? ((new Date(this.$commonJs.todayDate + ' ' + p.data.endTime).getTime() - new Date().getTime()) / 1000) : 0
        console.log('bishiTime', this.bishiTime)
        this.$nextTick(p => {
          this.timeCount()
        })
      })
    },
    timeCount () {
      bishiInterVal = setInterval(p => {
        this.bishiTime--
      }, 1000)
    },
    returnHour (time, type, number) {
      if (!time || time < 0) {
        return [0, 0][number]
      }
      if (type === 1) {
        let num = Math.floor(time / 3600)
        return num < 10
          ? ['0', num][number]
          : [Math.floor(num / 10), num % 10][number]
      }
      if (type === 2) {
        let num = Math.floor((time / 60) % 60)
        return num < 10
          ? ['0', num][number]
          : [Math.floor(num / 10), num % 10][number]
      }
      if (type === 3) {
        let num = Math.floor(time % 60)
        return num < 10
          ? ['0', num][number]
          : [Math.floor(num / 10), num % 10][number]
      }
    },
    openGoodDetail (item) {
      const newData = this.$router.resolve({
        name: 'myGoodsDetail',
        query: {
          id: item.id
        }
      })
      window.open(newData.href)
    },
    showDetailFun (item) {
      this.showDetail2 = true
      let wareData = this.WarehouseList.find(p => {
        return p.id === item.warehouseId
      })
      console.log(wareData)
      if (wareData) {
        this.$nextTick(p => {
          // eslint-disable-next-line no-undef
          map = new AMap.Map('container', {
            resizeEnable: true,
            center: [parseFloat(wareData.longitude), parseFloat(wareData.latitude)],
            zoom: 13
          })
          clearMarker()
          addMarker(parseFloat(wareData.longitude), parseFloat(wareData.latitude), wareData.name)
        })
      }
    },
    allSearchChangeFun (type) {
      if (type) {
        this.postData.secondCategoryList = []
      }
      setTimeout(p => {
        this.getAllList(1)
      }, 20)
    },
    searchTab (flag) {
      if (flag) {
        clearTimeout(searchTimeOut)
        searchTimeOut = setTimeout(p => {
          this.getAllList(1)
        }, 500)
      } else {
        setTimeout(p => {
          this.getAllList(1)
        }, 20)
      }
    },
    initSearch (e) {
      this.postData.keyWord = e
      this.getAllList(1)
    },
    changeShowDetail () {
      this.showDetail = !this.showDetail
      const father = document.getElementById('detailSearchPlace')
      if (this.showDetail) {
        father.style.height = father.childNodes[0].clientHeight + 0 + 'px'
      } else {
        father.style.height = '0px'
        for (let i = 0; i < this.showMoreModel.length; i++) {
          this.showMoreModel[i] = false
        }
        for (let i = 0; i < this.showMoreModelDivName.length; i++) {
          document.getElementById(this.showMoreModelDivName[i]).style.height = '27px'
        }
      }
      this.$forceUpdate()
    },
    changeMedu (index, name) {
      this.multipleShowModel[index] = !this.multipleShowModel[index]
      if (this.multipleShowModel[index]) {

      } else {
        this.postData[name] = []
      }
      this.$forceUpdate()
    },
    openMore (id, index) {
      this.showMoreModel[index] = !this.showMoreModel[index]
      const father = document.getElementById(id)
      const height = father.childNodes[0].clientHeight
      const detailSearchPlaceDom = document.getElementById('detailSearchPlace')
      const detailSearchPlaceDomHeight = parseInt(detailSearchPlaceDom.style.height.replace('px', ''))
      if (this.showMoreModel[index]) {
        father.style.height = height + 'px'
        if (height > 30) {
          detailSearchPlaceDom.style.height = detailSearchPlaceDomHeight + height - 27 + 'px'
        }
      } else {
        father.style.height = '27px'
        if (height > 30) {
          detailSearchPlaceDom.style.height = detailSearchPlaceDomHeight - height + 27 + 'px'
        }
      }
      this.$forceUpdate()
    },
    searchWeight (item) {
      this.postData.minWeight = item.min
      this.postData.maxWeight = item.max
      this.getAllList(1)
    },
    async getAllSearchList (reflashType, name, currPage, pageSize) {
      if (reflashType === 0 || !reflashType) {
        let p = await this.$axiox.post('/baigang/app/good/queryMaterialQualityList', { name: name || '', currPage: currPage || 1, pageSize: pageSize || 9999 })
        for (let i = 0; i < p.data.list.length; i++) {
          p.data.list[i].checked = false
        }
        this.MaterialQualityList = p.data.list
      }
      if (reflashType === 1 || !reflashType) {
        let p = await this.$axiox.post('/baigang/app/good/querySteelMillList', { name: name || '', currPage: currPage || 1, pageSize: pageSize || 9999 })
        for (let i = 0; i < p.data.list.length; i++) {
          p.data.list[i].checked = false
        }
        this.SteelMillList = p.data.list
      }
      if (reflashType === 2 || !reflashType) {
        let p = await this.$axiox.post('/baigang/app/good/queryWarehouseList', { name: name || '', currPage: currPage || 1, pageSize: pageSize || 9999 })
        for (let i = 0; i < p.data.list.length; i++) {
          p.data.list[i].checked = false
        }
        this.WarehouseList = p.data.list
      }
      if (reflashType === 3 || !reflashType) {
        let p = await this.$axiox.post('/baigang/app/good/queryOriginPlaceList', { name: name || '', currPage: currPage || 1, pageSize: pageSize || 9999 })
        for (let i = 0; i < p.data.list.length; i++) {
          p.data.list[i].checked = false
        }
        this.ChandiList = p.data.list
      }
      this.$nextTick(p => {
        setTimeout(p => {
          const father = document.getElementById('detailSearchPlace')
          if (father) {
            father.style.height = father.childNodes[0].clientHeight + 0 + 'px'
            console.log(father.childNodes[0].clientHeight)
          }
        }, 100)
      })
    },
    allCollect (item) {
      console.log('asdfadsf')
      console.log(item)
      if (this.isBishiTime) {
        this.$commonJs.alertTips({
          type: 'error',
          titleL: '现在是闭市时间,营业时间外不能下单',
          content: '现在是闭市时间,营业时间外不能下单',
          stayTime: 5
        })
        return false
      }
      let that = this
      if (this.isRegister) {
        this.$axiox.post('/baigang/buyer/center/addGoodToCart', {
          amount: item.number || 1,
          goodId: item.id,
          skuId: item.skuList[0].id,
          settlementType: item.chooseMethod
        }).then(p => {
          if (p.data) {
            that.$commonJs.alertTips({
              type: 'success',
              title: '成功:',
              content: '添加成功',
              stayTime: 5
            })
            if (that.$refs.allMallSerch) {
              that.$refs.allMallSerch.getShopList()
            }
            if (that.$parent) {
              console.log(that.$parent)
              that.$parent.refreshShopCar()
            }
          }

          // setTimeout( () => {
          //   that.isRefreshShopCar = `isRefreshShopCar${new Date().getTime()}`
          // }, 500 )
        })
        // this.$axiox.post('/baigang/buyer/center/addFavorite', {
        //   goodId: item.id,
        //   memberId: localStorage.getItem('memberId')
        // }).then(p => {
        //   this.$commonJs.alertTips({
        //     type: 'success',
        //     title: '成功',
        //     content: '添加成功',
        //     stayTime: 5
        //   })
        //   this.getcollectList()
        // })
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请先进行登录',
          stayTime: 5
        })
        // window.location.href = pubilshSet.userCenterHostUrl + 'login'
      }
    },
    showModelFun (item) {
      if (!this.isRegister) {
        this.askList = []
        this.askList[0] = item
        this.showModel = true
      } else {
        this.askList = []
        this.askList[0] = item
        this.askData.mobile = this.MemberInfo.userMobile
        this.askData.name = this.MemberInfo.nickName
        this.askData.remarks = '快捷咨询'
        this.applySure()
      }
    },
    showAllModel () {
      if (this.collectList.length > 0) {
        if (!this.isRegister) {
          let showList = []
          for (let i = 0; i < this.collectList.length; i++) {
            showList.push(this.collectList[i].shopGoodEntity)
          }
          this.askList = showList
          this.showModel = true
        } else {
          let showList = []
          for (let i = 0; i < this.collectList.length; i++) {
            showList.push(this.collectList[i].shopGoodEntity)
          }
          this.askList = showList
          this.askData.mobile = this.MemberInfo.userMobile
          this.askData.name = this.MemberInfo.nickName
          this.askData.remarks = '快捷咨询'
          this.applySure()
        }
      }
    },
    changeCate (index) {
      this.selectIndex = index
      this.postData.secondCategoryList[0] = this.CategoryList[this.selectIndex].categoryId
      this.getAllList(1)
    },
    getAllList (page) {
      let data = JSON.parse(JSON.stringify(this.postData))
      if (data.maxWidth && data.minWidth) {
      } else {
        delete data['maxWidth']
        delete data['minWidth']
      }
      if (data.maxLength && data.minLength) {
      } else {
        delete data['maxLength']
        delete data['minLength']
      }
      if (data.maxThickness && data.minThickness) {
      } else {
        delete data['maxThickness']
        delete data['minThickness']
      }
      if (data.maxWeight && data.minWeight) {
      } else {
        delete data['maxWeight']
        delete data['minWeight']
      }
      data.currPage = page
      this.$axiox.post('/baigang/app/good/queryPcGoodPage', data).then(p => {
        this.goodList = p.data.list
        this.postData.currPage = page
        this.page = page
        this.totalPage = p.data.totalPage
        this.totalCount = p.data.totalCount
        if (this.goodList.length > 0 && this.postData.keyWord) {
          let data2 = {
            hotWord: this.postData.keyWord
          }
          this.$axiox.post('/baigang/app/good/addHotWordSearch', data2).then(p => {

          })
        }
      })
    },
    resetSearch () {
      this.postData = {
        ascs: [],
        secondCategoryList: [],
        warehouseIdList: [],
        materialQualityIdList: [],
        steelMillIdList: [],
        originPlaceIdList: [],
        descs: [],
        maxPrice: '',
        accountName: '',
        publishChannel: '2',
        minPrice: '',
        maxLength: '',
        futuresFlag: this.showXianhuo ? '0' : '',
        maxThickness: '',
        maxWeight: '',
        maxWidth: '',
        minLength: '',
        minThickness: '',
        minWeight: '',
        minWidth: '',
        name: '',
        keyWord: this.$route.query.name,
        guige: '',
        pageSize: this.$commonJs.commonPageSize,
        currPage: 0,
        askList: []
      }
    },
    getcollectList () {
      this.$axiox.post('/baigang/buyer/center/queryMemberFavoritePage', { currPage: 0, pageSize: 9999 }).then(p => {
        this.collectList = p.data.list
      })
    },
    getAllCate () {
      this.$axiox.get('/baigang/app/good/queryCategoryList?name=').then(p => {
        this.CategoryList = p.data.filter(p => { return p.level === 2 })
        // this.postData.secondCategoryList[0] = this.CategoryList[this.selectIndex].categoryId
        this.getAllList(1)
      })
    },
    applySure () {
      let goodList = []
      for (let i = 0; i < this.askList.length; i++) {
        let data = {
          goodId: this.askList[i].id
        }
        goodList.push(data)
      }
      this.$axiox.post('/baigang/buyer/center/addManualService', {
        memberId: window.localStorage.getItem('memberId'),
        mobile: this.askData.mobile,
        name: this.askData.name,
        remarks: '快捷咨询',
        goodList: goodList
      }).then(p => {
        switch (p.code) {
          case 0:
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '申请成功，客服会立马与您联系',
              stayTime: 5
            })
            this.showModel = false
            break
          case 500:
            // this.$commonJs.alertTips({
            //   type: 'success',
            //   title: '成功',
            //   content: '申请成功，客服会立马与您联系',
            //   stayTime: 5
            // })
            break
          default:
            break
        }
        this.showModel = false
      })
    },
    removeCollect (item) {
      this.$commonJs.doubleComfirm({
        content: '是否移除该收藏？',
        successFun: msg => {
          this.$axiox.del('/baigang/buyer/center/removeFavorite/' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '移除成功',
              stayTime: 5
            })
            this.getcollectList()
          })
        },
        errorFun: msg => {
        }
      })
    }
  }
}
// 实例化点标记
function addMarker (x, y, name) {
  // eslint-disable-next-line no-undef
  marker = new AMap.Marker({
    icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
    position: [x, y],
    // eslint-disable-next-line no-undef
    offset: new AMap.Pixel(-13, -30)
  })
  var markerContent = document.createElement('div')

  // 点标记中的图标
  var markerImg = document.createElement('img')
  markerImg.className = 'markerlnglat'
  markerImg.src = '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png'
  markerContent.appendChild(markerImg)

  // 点标记中的文本
  var markerSpan = document.createElement('span')
  markerSpan.className = 'marker'
  markerSpan.innerHTML = name
  markerContent.appendChild(markerSpan)
  marker.setContent(markerContent)
  marker.setMap(map)
}
// function updateIcon() {
//
//   marker.setIcon('//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png')
// }

// function updateContent() {
//
//   if (!marker) {
//     return;
//   }
//
//   // 自定义点标记内容
//   var markerContent = document.createElement("div");
//
//   // 点标记中的图标
//   var markerImg = document.createElement("img");
//   markerImg.className = "markerlnglat";
//   markerImg.src = "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png";
//   markerContent.appendChild(markerImg);
//
//   // 点标记中的文本
//   var markerSpan = document.createElement("span");
//   markerSpan.className = 'marker';
//   markerSpan.innerHTML = "Hi，我被更新啦！";
//   markerContent.appendChild(markerSpan);
//
//   marker.setContent(markerContent); //更新点标记内容
//   marker.setPosition([116.391467, 39.927761]); //更新点标记位置
// }

// 清除 marker
function clearMarker () {
  if (marker) {
    marker.setMap(null)
    marker = null
  }
}
</script>
<style scoped>
.searchBlock {
  width: 600px;
  height: 40px;
  border: 1px solid #d71e1e;
  border-radius: 4px;
}
.searchBlock input {
  flex: 1;
  height: 100%;
  border: none;
  border-radius: 4px 0px 0px 4px;
  padding: 0 10px;
}
.searchBlock div {
  padding-left: 10px;
  padding-right: 9px;
  height: 100%;
  background: #d71e1e;
  color: #fff;
  font-weight: bold;
  text-align: center;
  line-height: 40px;
}
.yellowBtn {
  height: 37px;
  background: #d71e1e;
  font-size: 17px;
  font-weight: 600;
  color: #ffffff;
  width: 202px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  transition: all 0.2s;
}
.yellowBtn:hover {
  box-shadow: 0px 0px 5px 0px #999;
}
.yellowBtn img {
  margin-right: 18px;
}
.typeBlock {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
}
.typeBlock div {
  padding: 5px 12px;
  border-radius: 2px;
  border: 1px solid #dddddd;
  margin: 0 22px 14px 0;
  cursor: pointer;
}
.typeBlock div.selected {
  border: 1px solid #d71e1e;
  color: #d71e1e;
}
.filterBlock {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 12px;
  justify-content: space-between;
  background-color: #fff;
  height: 40px;
  border: 1px solid #dddddd;
  margin-bottom: -1px;
}
.filterBlock .selected {
  margin-left: 30px;
  padding-right: 17px;
}
.filterBlock .selected .seltedItem {
  margin-left: 12px;
}
.filterBlock .selected .seltedItem div {
  position: relative;
  color: #d71e1e;
  padding: 5px 12px 5px 6px;
  border: 1px solid #d71e1e;
  margin-right: 15px;
  /*flex-wrap: wrap;*/
}
.filterBlock .selected .seltedItem div img {
  position: absolute;
  right: -7px;
  top: 7px;
}
.filterBlock .norm {
  margin-left: 30px;
  height: 30px;
  line-height: 30px;
}
.filterBlock .norm .inputBlock {
  background-color: #fff;
  border: 1px solid #dddddd;
}
.filterBlock .norm .inputBlock span {
  padding: 0 6px;
  border-right: 1px solid #dddddd;
}
.filterBlock .norm .inputBlock input {
  height: 30px;
  font-size: 12px;
  padding: 0 6px 0 16px;
  border: none;
}
.filterBlock .norm .normBtn {
  height: 30px;
  padding: 0 14px;
}
.orderBlock {
  height: 54px;
  justify-content: space-around;
  background: #fafafa;
  border-radius: 4px 4px 0px 0px;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 15px;
}
.resultList {
  height: 600px;
  overflow-y: auto;
}
.bishi {
  display: flex;
  justify-content: space-between;
  /* background-color: #d71e1e; */
  border-top: 0.5px solid #fff;
  align-items: center;
  border-bottom: 0.5px solid #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/page/mySteelMall/SteelMallResult.vue